import React from "react";
import { Button, Col, Input, Row } from "reactstrap";
import Select2 from "react-select2-wrapper";

function HoursByServiceOrderTableHeader(props) {
  return (
    <>
      <Row>
        <Col lg="6">
          <h3 className="mb-0">Chamados por ordem de serviço</h3>
        </Col>
      </Row>

      <Row style={{ paddingTop: "3vh" }}>
        <Col className="mb-3" lg="4">
          <label className="form-control-label" htmlFor="customer">
            Cliente
          </label>
          <Select2
            type="text"
            id="customer"
            value={props.customer?._id}
            onChange={(e) => {
              props.selectCustomer(e.target.value);
            }}
            options={{
              size: "small",
              placeholder: "Selecione um Cliente",
              language: {
                noResults: function () {
                  return "Nenhum cliente encontrado.";
                },
              },
            }}
            data={props.customers.map((customer) => ({
              id: customer._id,
              text: customer.shortName,
            }))}
          />
        </Col>

        <Col className="mb-3" lg="4">
          <label className="form-control-label" htmlFor="project">
            Projeto
          </label>
          <Select2
            id="project"
            disabled={!props.customer}
            className="form-control"
            type="text"
            value={props.project}
            onSelect={(e) => props.setProject(e.target.value)}
            options={{
              placeholder: "Selecione um projeto",
              language: {
                noResults: function () {
                  return "Nenhum projeto encontrado.";
                },
              },
            }}
            data={[
              { id: "ALL", text: "Todos os projetos" },
              ...props.projects
                .filter((project) =>
                  project.name?.toLowerCase().includes("suporte") || project.name?.toLowerCase().includes("desk")
                )
                .map((project) => ({
                  id: project._id,
                  text: `${project.name} | ${project.code}`,
                })),
            ]}
          />
        </Col>
      </Row>

      <Row className="mt-4 align-items-center">
        <Col lg="2">
          <label className="form-control-label" htmlFor="dateFrom">
            Data de
          </label>
          <Input
            id="dateFrom"
            type="date"
            value={props.dateFrom}
            onChange={(e) => props.setDateFrom(e.target.value)}
          />
        </Col>

        <Col lg="3">
          <label className="form-control-label" htmlFor="dateTo">
            Data até
          </label>
            <Input
              id="dateTo"
              type="date"
              value={props.dateTo}
              onChange={(e) => props.setDateTo(e.target.value)}
            />

        </Col>

        <Col lg="2">
          <label className="form-control-label" htmlFor="numeroChamado">
            Nº Chamado
          </label>
          <Input
            id="numeroChamado"
            type="text"
            placeholder="Nº Chamado"
            value={props.numeroChamado}
            onChange={(e) => props.setNumeroChamado(e.target.value)}
          />
        </Col>

        <Col lg="2" className="mt-4">
          <Button type="button" onClick={() => props.fetchConsultants()}>
            Filtrar
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default HoursByServiceOrderTableHeader;
